module.exports = __webpack_public_path__ + "img/Abstraction.a35edb77.svg";